export const validationRules = {
    standardValidation: {
        required: true,
        min: 2,
        regex: /^[a-zA-Z\u00C0-\u017F -]+$/i
    },
    standardConditionalValidation: (isRequired) => {
        if (!isRequired) {
            return {
                required: false,
            }
        }

        return {
            required: true,
            min: 2,
            regex: /^[a-zA-Z\u00C0-\u017F -]+$/i
        }
    },
    simpleValidation: {
        required: true,
        regex: /^[^<>]+$/i
    },
    simpleConditionalValidation: (isRequired) => {
        if (!isRequired) {
            return {
                required: false,
            }
        }

        return {
            required: true,
            regex: /^[^<>]+$/i
        }
    },
    postalCodeValidation: {
        required: true,
        regex: /^[\d-]+$/i
    },
    postalCodeConditionalValidation: (isRequired) => {
        if (!isRequired) {
            return {
                required: false,
            }
        }

        return {
            required: true,
            regex: /^[\d-]+$/i
        }
    },
    nipValidation: {
        required: true,
        regex: /^((\d{3}-\d{3}-\d{2}-\d{2})|(\d{3}-\d{2}-\d{2}-\d{3})|(\d{10}))$/i
    },
    nipConditionalValidation: (isRequired) => {
        if (!isRequired) {
            return {
                required: false,
            }
        }

        return {
            required: true,
            regex: /^((\d{3}-\d{3}-\d{2}-\d{2})|(\d{3}-\d{2}-\d{2}-\d{3})|(\d{10}))$/i
        }
    },
    emailValidation: {
        required: true,
        max: 50,
        regex: /^(?!(?:(?:\x22?\x5C[\x00-\x7E]\x22?)|(?:\x22?[^\x5C\x22]\x22?)){255,})(?!(?:(?:\x22?\x5C[\x00-\x7E]\x22?)|(?:\x22?[^\x5C\x22]\x22?)){65,}@)(?:(?:[\x21\x23-\x27\x2A\x2B\x2D\x2F-\x39\x3D\x3F\x5E-\x7E\p{L}\p{N}]+)|(?:\x22(?:[\x01-\x08\x0B\x0C\x0E-\x1F\x21\x23-\x5B\x5D-\x7F\p{L}\p{N}]|(?:\x5C[\x00-\x7F]))*\x22))(?:\.(?:(?:[\x21\x23-\x27\x2A\x2B\x2D\x2F-\x39\x3D\x3F\x5E-\x7E\p{L}\p{N}]+)|(?:\x22(?:[\x01-\x08\x0B\x0C\x0E-\x1F\x21\x23-\x5B\x5D-\x7F\p{L}\p{N}]|(?:\x5C[\x00-\x7F]))*\x22)))*@(?:(?:(?!.*[^.]{64,})(?:(?:(?:xn--)?[a-z0-9]+(?:-+[a-z0-9]+)*\.){1,126})+(?:(?:[a-z][a-z0-9]*)|(?:(?:xn--)[a-z0-9]+))(?:-+[a-z0-9]+)*)|(?:\[(?:(?:IPv6:(?:(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){7})|(?:(?!(?:.*[a-f0-9][:\]]){7,})(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,5})?::(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,5})?)))|(?:(?:IPv6:(?:(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){5}:)|(?:(?!(?:.*[a-f0-9]:){5,})(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,3})?::(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,3}:)?)))?(?:(?:25[0-5])|(?:2[0-4][0-9])|(?:1[0-9]{2})|(?:[1-9]?[0-9]))(?:\.(?:(?:25[0-5])|(?:2[0-4][0-9])|(?:1[0-9]{2})|(?:[1-9]?[0-9]))){3}))\]))$/iu
    },
    amountOtherValidation: (isRequired) => {
        return {
            required: isRequired,
            numeric: true,
            min_value: 2
        }
    },
    listItemValidation: (isRequired) => {
        return {
            required: isRequired
        };
    },
}
